export const normalizeAppPath = (value: string | null | undefined): string => {
  const normalizedValue = value?.trim() ?? ''

  if (normalizedValue.length === 0 || normalizedValue === '/') {
    return '/'
  }

  if (
    normalizedValue.startsWith('/') ||
    normalizedValue.startsWith('#') ||
    /^[a-z]+:/i.test(normalizedValue)
  ) {
    return normalizedValue
  }

  return `/${normalizedValue}`
}

// Номер страницы списка из ?page= (целое ≥ 1); null — параметра нет или он не число.
export const pageNumberFromQuery = (query: Record<string, unknown> = {}): number | null => {
  const rawPage = Array.isArray(query.page) ? query.page[0] : query.page
  const page = Number.parseInt(String(rawPage ?? ''), 10)

  return Number.isInteger(page) && page >= 1 ? page : null
}

// Путь для canonical: без UTM, рекламных меток (ysclid, yclid) и поиска (?q=) — у страницы
// один canonical. Сохраняется только пагинация (?page=N, N > 1): это отдельные страницы списка.
export const canonicalPath = (path: string, query: Record<string, unknown> = {}): string => {
  const page = pageNumberFromQuery(query)

  return page !== null && page > 1 ? `${path}?page=${page}` : path
}
